import React from "react";
import "../styles/Dashboard.css";
import { motion } from "framer-motion";
import { ChevronDown, Search, FileText } from "lucide-react";
import { courseData } from "../data/courseData";
import { useNavigate } from "react-router-dom";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard">
      {/* Header */}
      <motion.div
        className="dashboard-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1>Dashboard</h1>
        <h2>
          Hi, Volunteer! <span className="wave">👋</span>
        </h2>
      </motion.div>

      {/* Latest Announcements */}
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h3>Latest announcements</h3>
        <p className="muted">(No announcements have been posted yet.)</p>
      </motion.div>

      {/* Timeline */}
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h3>Timeline</h3>

        <div className="timeline-controls">
          <button className="select">
            Next 7 days <ChevronDown size={16} />
          </button>

          <button className="select">
            Sort by dates <ChevronDown size={16} />
          </button>

          <div className="search-box">
            <Search size={16} />
            <input type="text" placeholder="Search by activity type or name" />
          </div>
        </div>

        <div className="timeline-empty">
          <FileText size={40} />
          <p>No activities require action</p>
        </div>
      </motion.div>

      {/* Courses */}
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <h3>Recently added courses</h3>
        <div className="courses">
          {courseData.map((course) => (
            <motion.div
              key={course.id}
              className={`course-card ${course.color}`}
              whileHover={{ scale: 1.03 }}
              onClick={() => navigate(`/course-study/${course.id}`)}
            >
              <div className="course-img" />
              <div className="course-info">
                <h4>{course.code}</h4>
                <p>{course.title}</p>
              </div>
            </motion.div>
          ))}
        </div>{" "}
      </motion.div>
    </div>
  );
};

export default Dashboard;
